import { sortSizes } from "./component-library222.mjs";
import LinkButton from "./component-library3.mjs";
import "./component-library223.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "OfferTileVariant",
  components: { LinkButton },
  props: {
    type: { type: String, required: true },
    variants: {
      type: Array,
      required: true
    }
  },
  computed: {
    mappedVariants() {
      if (!this.variants || this.variants.length === 0)
        return [];
      const sortedVariants = this.type === "size" ? sortSizes(this.variants) : this.variants;
      return sortedVariants.map(({ offer, active, name, path }) => {
        var _a;
        return {
          active,
          articleNumber: (_a = offer == null ? void 0 : offer.scopedProduct) == null ? void 0 : _a.articleNumber,
          path,
          name
        };
      }).filter(({ name }) => name !== "");
    }
  },
  methods: {
    clickedItem(path) {
      if (this.$router) {
        this.$router.push(path);
        return;
      }
      window.open(path, "_self");
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("ul", { staticClass: "offer-tile-variant", class: { "offer-tile-variant--price": _vm.type === "price" } }, _vm._l(_vm.mappedVariants, function(variant) {
    return _c("li", { key: variant.articleNumber, staticClass: "offer-tile-variant__entry" }, [_c("LinkButton", { staticClass: "offer-tile-variant__btn", class: { "offer-tile-variant__btn--active": variant.active }, attrs: { "type": "button", "tag": "button", "no-styling": "" }, on: { "click": function($event) {
      $event.preventDefault();
      return _vm.clickedItem(variant.path);
    } } }, [_vm._v(" " + _vm._s(variant.name) + " ")])], 1);
  }), 0);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "d69c3869",
  null,
  null
);
const OfferTileVariant = __component__.exports;
export {
  OfferTileVariant as default
};
